import { BaseError } from '@dynamic-labs-sdk/client';

export class NoPendingPhantomRequestError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'no_pending_phantom_request_error',
      docsUrl: null,
      name: 'NoPendingPhantomRequestError',
      shortMessage:
        'No pending Phantom request found. The request may have already been processed or expired.',
    });
  }
}
